module.exports = __webpack_public_path__ + "img/xcx1.bd3ce991.png";